import get from 'lodash.get';

const getRecaptchaEnabled = (rootState) =>
  get(rootState, 'config.common.recaptcha.enabled_for_user_registration');

export default getRecaptchaEnabled;
